<template>
  <transition name='fade'>
    <div
      class="modal share_box"
      v-if='visible && shareData.length>0'
      style="z-index:1001;"
    >
      <div
        class="share"
        @click.stop='closeQrcode()'
      >
        <div class="title msp_icon_close">
          <span
            class="title_name"
            v-if="shareData[0].doc_type!='document'"
          >分享稿件</span>
          <span
            class="title_name"
            v-if="shareData[0].doc_type=='document'"
          >分享文档</span>
          <span
            class="title_name"
            style="color:#fd4a4a;"
          >（分享至数智融媒时安全设置和失效日期不生效）</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="share_parameter">
          <div
            class="parameter"
            style="margin-bottom:14px;"
          >
            <span>安全设置：</span>
            <el-checkbox v-model="safeChecked"></el-checkbox>
            <span style="margin-right:14px;margin-left:6px;">加密分享</span>
            <el-input
              v-model="codeInput"
              placeholder=""
              disabled
              v-show='safeChecked'
            ></el-input>
            <span
              class="code_title"
              style="margin-left:14px;"
              v-show='safeChecked'
            >提取码</span>
          </div>
          <div class="parameter">
            <span>失效日期：</span>
            <el-checkbox v-model="failureDateChecked"></el-checkbox>
            <span style="margin-right:14px;margin-left:6px;">永久有效</span>
            <el-date-picker
              v-model="failureDateInput"
              type="date"
              placeholder="选择日期"
              value-format='timestamp'
              :clearable='false'
              @change='choiceLostEffectTime'
              :picker-options='pickerOptions'
              v-show="!failureDateChecked"
            >
            </el-date-picker>
          </div>
          <div class="parameter">
            <span>权限选择：</span>
            <el-checkbox v-model="editorChecked"></el-checkbox>
            <span
              style="margin-right:14px;margin-left:6px;"
              v-if="shareData[0].doc_type!='document'"
            >编辑稿件</span>
            <span
              style="margin-right:14px;margin-left:6px;"
              v-if="shareData[0].doc_type=='document'"
            >编辑文档</span>
          </div>

          <div class="parameter">
            <span>备注说明：</span>
            <el-input
              type="textarea"
              placeholder="点击输入分享备注，最多100字"
              v-model="remarkDescrip"
              show-word-limit
              :maxlength='100'
            >
            </el-input>
          </div>
        </div>
        <div class="share_object">
          <div class="share_object_detail">
            <span>分享到</span>
          </div>
          <div class="share_object_detail">
            <div
              class="each_item"
              @click.stop='shareDataMedia()'
            >
              <img
                src="../../../static/img/shuzhirongmei.png"
                alt=""
              >
              <div class="each_item_title">
                <span>数智融媒</span>
              </div>
            </div>
            <div
              class="each_item bdsharebuttonbox"
              @click.stop='copyShareUrlLink("QQ")'
            >
              <img
                src="../../../static/img/qqpic.png"
                alt=""
              >
              <div class="each_item_title">
                <span>QQ</span>
              </div>
            </div>

            <div
              class="each_item"
              @click.stop='copyShareUrlLink("weixin")'
            >
              <img
                src="../../../static/img/wechartpic.png"
                alt=""
              >
              <div class="each_item_title">
                <span>微信</span>
              </div>
              <div
                id='qrcode'
                class="qrcode"
                v-show="isShowQrcode"
              ></div>
            </div>

            <div
              class="each_item"
              @click.stop='copyShareUrlLink("copy")'
            >
              <img
                src="../../../static/img/copyicon.png"
                alt=""
              >
              <div class="each_item_title">
                <span>复制链接</span>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div
        id='share_url_link'
        style="position:absolute;left:99999999px;top:99999999999px;"
      >
        <input
          type="text"
          v-model="copyShareLink"
          id='share_link_id'
        >
      </div>

    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'




export default {
  name: 'share',
  data () {
    return {
      visible: false,
      safeChecked: true,
      codeInput: '',
      lookChecked: true,
      editorChecked: true,
      failureDateChecked: true,
      failureDateInput: '',
      remarkDescrip: '',
      shareData: [],
      timeLostSize: 0,
      shareUrlLink: '',
      codeId: '',
      isShowQrcode: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('shareToOtherModel', (data) => {
      this.visible = true
      this.shareData = data
      this.failureDateInput = this.GetDateStr(7).getTime()
      this.getSafeCode()
    })
  },
  destroyed () {
    this.$root.eventHub.$off('shareToOtherModel')
  },
  components: {

  },
  computed: {
    copyShareLink () {
      if (this.safeChecked) {
        return this.shareUrlLink + '【' + this.shareData[0].title + '】' + '提取码：' + this.codeInput
      } else {
        return this.shareUrlLink + '【' + this.shareData[0].title + '】'
      }

    }
  },

  methods: {
    //封装时间函数
    GetDateStr (AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
      return dd
    },
    closeBox () {
      this.visible = false
    },
    choiceLostEffectTime (value) {
      if (value) {
        this.failureDateChecked = false
        this.timeLostSize = value
      } else {
        this.failureDateChecked = true
        this.timeLostSize = 0
      }

    },
    shareDataMedia () {
      var option = {
        editorChecked: this.editorChecked,
        timeLostSize: this.timeLostSize,
        remarkDescrip: this.remarkDescrip,
        codeInput: this.codeInput
      }

      this.$root.eventHub.$emit('sendAuditModel', this.shareData, 'shareToOther', option)

    },
    //获取code
    getSafeCode () {
      api._get(_SHAREURL_ + 'getSixCodeAndId', '').then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.codeInput = res.data.code
            this.codeId = res.data.id
          }

        } else {
          this.codeInput = ''
        }
      }).catch((error) => {
        console.log(error)
        this.codeInput = ''
      })
    },

    copyShareUrlLink (type) {
      this.isShowQrcode = false
      var url = _SHAREURL_ + 'creatShareUrl'
      var code = ''
      if (this.safeChecked) {
        code = this.codeInput
      } else {
        code = ''
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                           // 必须字段： 参数
          "articleId": this.shareData[0].id, //稿件id
          "title": this.shareData[0].title,                                //稿件标题
          "canEdit": this.editorChecked,                                     //能否编辑
          "invalidTime": this.timeLostSize,                         //失效日期
          "remarks": this.remarkDescrip,                         //备注
          "shareUserId": this.$store.state.userinfo.usercode,         //分享人id
          "sharedUserIds": [],                                  //被分享人id集合
          'code': code,
          'id': this.codeId,
          'doc_type': this.shareData[0].doc_type

        }
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.shareUrlLink = res.data
          if (type === 'copy') {
            this.copyTextareaCode()
          } else if (type === 'weixin') {
            this.createQrCode()
          } else if (type === 'QQ') {
            this.shareToQq()
          }

        } else {
          this.shareUrlLink = ''
        }
      }).catch((error) => {
        this.shareUrlLink = ''
      })

    },
    copyTextareaCode () {
      if (this.shareUrlLink) {
        this.$nextTick(() => {
          var codeText = document.getElementById('share_link_id');
          codeText.select(); // 选择对象
          document.execCommand("Copy")
          this.$notify.success({
            title: '成功',
            message: '复制成功'
          });
        })
      } else {
        this.$notify.error({
          title: '失败',
          message: '复制失败，请重试'
        });
      }
    },

    createQrCode () {
      this.isShowQrcode = true
      document.getElementById("qrcode").innerHTML = ""
      var self = this
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        text: self.shareUrlLink,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });

    },
    shareToQq () {
      var des = ''
      if (this.safeChecked) {
        des = '提取码' + this.codeInput
      } else {
        des = ''
      }

      var p = {
        url: this.shareUrlLink,/*获取URL，可加上来自分享到QQ标识，方便统计*/
        desc: des, /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/
        title: this.shareData[0].title,/*分享标题(可选)*/
        summary: this.shareData[0].title,/*分享描述(可选)*/
        pics: '',/*分享图片(可选)*/
        flash: '', /*视频地址(可选)*/
        //commonClient : true, /*客户端嵌入标志*/
        site: 'qq分享'/*分享来源 (可选) ，如：QQ分享*/
      };


      var s = [];
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''));
      }
      var target_url = "http://connect.qq.com/widget/shareqq/index.html?" + s.join('&');
      window.open(target_url);

    },
    closeQrcode () {
      this.isShowQrcode = false
    }



  },
  watch: {
    shareData () {
      if (this.shareData.length === 0) {
        this.visible = false
      }
    },
    failureDateChecked () {
      if (this.failureDateChecked) {
        this.timeLostSize = 0
      } else {
        this.timeLostSize = this.failureDateInput
      }

    },
    visible () {
      if (!this.visible) {
        this.safeChecked = true
        this.failureDateChecked = true
        this.editorChecked = true
        this.remarkDescrip = ''
      }
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.share_box
  .share
    width 500px
    height 500px
    border-radius 6px
    background #fff

    .title
      clear both
      padding 0 14px 0 14px
      height 50px
      border-bottom 1px solid #E6E7EB

      .title_name
        span-medium-title()
        float left
        line-height 50px

      .iconfont
        float right
        font-size 18px
        line-height 50px
        cursor pointer

    .share_parameter
      margin-bottom 14px
      padding-top 24px
      padding-left 78px

      .parameter
        display flex
        margin-bottom 4px

        span
          input-title()
          line-height 36px

        span.code_title
          time-title()

    .share_object
      margin-left 78px
      width 340px
      border-top 1px dashed #E6E7EB

      .share_object_detail
        display flex
        padding-top 14px

        span
          input-title()

        .each_item
          position relative
          margin-right 18px
          cursor pointer

          img
            display block
            margin-bottom 8px
            width 70px
            height 70px

          .each_item_title
            width 70px
            text-align center

          .qrcode
            position absolute
            top -102px
            left -10px
            width 100px
            height 100px
</style>